// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/mini-css-extract-plugin/dist/loader.js??ref--7-1!../../../node_modules/css-loader/index.js??ref--7-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/lib/index.js??ref--7-3!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DocumentEditView.vue?vue&type=style&index=0&id=b2a0d720&scoped=true&lang=css&");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("08ca37c1", content, true, {});